import React from 'react'
import { Skeleton } from '@welbe/web-design-system'

import { ContainerSkeleton } from './SurveyForm.styles'

export const SurveySkeleton = () => {
	return (
		<ContainerSkeleton>
			<Skeleton height="62px" />
			<Skeleton height="62px" />
			<Skeleton height="62px" />
			<Skeleton height="62px" />
			<Skeleton height="62px" />
		</ContainerSkeleton>
	)
}
